<template>
  <v-dialog
    v-model="isHeaderCustomizeDialogOpen"
    width="1000"
  >
    <v-card class="pa-3">
      <v-layout justify-space-between>
        <h4 class="mt-2 ml-2 mb-2">分類設定</h4>
        <v-btn
          flat
          outline
          icon
          small
          color="#bbbbbb"
          @click="resetHeader"
          type="submit">
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-layout>

      <v-divider></v-divider>

      <v-layout ma-3 row wrap align-center>
        <v-flex xs12 md1>
          基本ヘッダー :
        </v-flex>
        <v-flex xs12 md4 d-flex pt-2>
          <v-checkbox :disabled="true" v-model="headerSelected" value='dispId' label="id"></v-checkbox>
          <v-checkbox :disabled="true" v-model="headerSelected" value='subject' label="タイトル"></v-checkbox>
        </v-flex>
        <v-flex xs12 md7></v-flex>

        <v-flex xs12 md1 pt-4>
          変更ヘッダー :
        </v-flex>
        <v-flex xs12 md11 d-flex pt-2 class="md--mt-2">
          <v-checkbox v-model="headerSelected" value='customerName' label="顧客名"></v-checkbox>
          <v-checkbox v-model="headerSelected" value='createDate' label="要請日"></v-checkbox>
          <v-checkbox v-model="headerSelected" value='priority' label="優先順位"></v-checkbox>
          <v-checkbox v-model="headerSelected" value='status' label="状態"></v-checkbox>
        </v-flex>
        <v-flex xs12 md1></v-flex>
        <v-flex xs12 md11 d-flex pt-2>
          <v-checkbox v-model="headerSelected" value='agentName' label="担当者"></v-checkbox>
          <v-checkbox v-model="headerSelected" value='majorTaskType' label="大分類"></v-checkbox>
          <v-checkbox v-model="headerSelected" value='middleTaskType' label="中分類"></v-checkbox>
          <v-checkbox v-model="headerSelected" value='minorTaskType' label="小分類"></v-checkbox>
        </v-flex>
        <v-flex xs12 md1></v-flex>
        <v-flex xs12 md11 d-flex pt-2>
          <v-checkbox v-model="headerSelected" value='memo' label="メモ"></v-checkbox>
          <v-checkbox v-model="headerSelected" value='modifyDate' label="更新日"></v-checkbox>
          <v-checkbox v-model="headerSelected" value='ticketIncomingChannel' label="チャットツール"></v-checkbox>
          <v-checkbox v-model="headerSelected" value='tags' label="タグ"></v-checkbox>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>
<script>
import eventBus from '@/event_bus'
import event from '../../../enums/eventType'
import TicketListUtil from '../../../util/ticket_list_util'

export default {
  props: {
    updateHeader: Function
  },
  data: () => ({
    isHeaderCustomizeDialogOpen: false,
    headerSelected: []
  }),
  created () {
    eventBus.$on(event.OPEN_TICKET_LIST_HEADER_CUSTOMIZE_DIALOG, () => {
      this.isHeaderCustomizeDialogOpen = true
    })
  },
  watch: {
    headerSelected (value) {
      let headers = TicketListUtil.parseHeaderIntoJson(this.headerSelected)
      this.updateHeader(headers)
      localStorage.setItem('TICKET_LIST_COLUMN', JSON.stringify(headers))
    }
  },
  mounted () {
    this.headerSelected = TicketListUtil.parseJsonIntoHeader(localStorage.getItem('TICKET_LIST_COLUMN'))
  },
  methods: {
    resetHeader () {
      this.headerSelected = ['dispId', 'subject']
    }
  }
}
</script>

<style scoped>
  @media (min-width: 960px) {
    .md--mt-2 {
      margin-top: 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticketlist/layout/ticket_header_customize_dialog.vue